import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../src/core/api/axiosClient";

const initialState: any = {
  fault: [],
  isLoadingFaults: false,
  floorDetails: [],
  isLoadingFloorDetails: false,
  floorAssetsAndShapes: [],
  isLoadingFloorAssetsAndShapes: false,
  faultDetails: {},
  isLoadingFaultDetails: false,
  filter: {},
  isLoading: false,
  error: null,
  todayFaultsStats: [],
  isLoadingTodayFaultsStats: false,
  floorPlanByAsset: [],
  isLoadingFloorPlanByAsset: false,
};

export const getFaults: any = createAsyncThunk(
  "content/getFaults",
  async ({
    PageNum,
    pageSize,
    tcCode = null,
    siteCode = null,
    blockCode = null,
    floorCode = null,
    SortBy,
    SortDirection,
    isAcknowledged = null,
    faultType,
  }: any) => {
    const res = await axios.get(`/slpapp/Fault/getFaults`, {
      params: {
        pageNumber: PageNum,
        pageSize,
        tcCode,
        siteCode,
        blockCode,
        floorCode,
        SortBy,
        SortDirection,
        isAcknowledged,
        faultType,
      },
    });

    const data = await res.data;
    return data;
  },
);

export const getFaultById: any = createAsyncThunk(
  "content/getFaultById",
  async ({ id }: any) => {
    const res = await axios.get(`/slpapp/Fault/getFaultById`, {
      params: { id },
    });

    const data = await res?.data?.data;
    return data;
  },
);

export const getTodayFaultStats: any = createAsyncThunk(
  "content/getTodayFaultStats",
  async () => {
    const res = await axios.get(`/slpapp/Fault/getTodayFaultStats`);

    const data = await res?.data;

    return data;
  },
);

export const acknowledgementFault: any = createAsyncThunk(
  "content/acknowledgementByFaultCode",
  async ({ payload }: any) => {
    const res = await axios.put(`/slpapp/Fault/acknowledgement`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await res.data;
    return data;
  },
);

export const resolveFault: any = createAsyncThunk(
  "content/acknowledgementForResolve",
  async ({ payload }: any) => {
    const res = await axios.put(`/slpapp/Fault/resolve`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await res.data;
    return data;
  },
);

export const updateFloorPlan: any = createAsyncThunk(
  "content/updateFloorPlan",
  async ({ payload }: any) => {
    const res = await axios.put(
      `/slpapp/BlockToFloor/updateFloorPlans`,
      {
        updatedShapes: payload?.updatedShapes,
        similarFloors: payload?.similarFloors,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          blockCode: payload?.blockCode,
        },
      },
    );

    const data = await res.data;
    return data;
  },
);

export const getFloorDetails: any = createAsyncThunk(
  "content/floorDetails",
  async ({ blockCode, floorCode }: any) => {
    const res = await axios.get(`/slpapp/BlockToFloor/getFloorByBlockCode`, {
      params: { floorCode, blockCode },
    });

    const data = await res.data;
    return data;
  },
);

export const getFloorAssetsAndShapes: any = createAsyncThunk(
  "content/getFloorAssetsAndShapes",
  async ({ blockCode, floorCode, assetCode }: any) => {
    const res = await axios.get(`/slpapp/BlockToFloor/getFloorPlans`, {
      params: { blockCode, floorCode, assetCode },
    });

    const data = await res.data;
    return data;
  },
);

export const getFloorPlanByAsset: any = createAsyncThunk(
  "content/getFloorPlanByAsset",
  async ({ assetCode, isInitial = true }: any) => {
    const res = await axios.get(`/slpapp/BlockToFloor/getFloorPlanByAsset`, {
      params: { assetCode, isInitial },
    });

    const data = await res?.data?.data;
    return data;
  },
);

export const faultSlice = createSlice({
  name: "fault",
  initialState,
  reducers: {
    setFilter(state, action) {
      state.filter = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getFaults.pending, (state) => {
      state.isLoadingFaults = true;
    });
    builder.addCase(getFaults.fulfilled, (state, action) => {
      state.isLoadingFaults = false;
      state.faults = action.payload;
    });
    builder.addCase(getFaults.rejected, (state, action) => {
      state.isLoadingFaults = false;
      state.error = action.error.message;
    });

    builder.addCase(getFaultById.pending, (state) => {
      state.isLoadingFaultDetails = true;
    });
    builder.addCase(getFaultById.fulfilled, (state, action) => {
      state.isLoadingFaultDetails = false;
      state.faultDetails = action.payload;
    });
    builder.addCase(getFaultById.rejected, (state, action) => {
      state.isLoadingFaultDetails = false;
      state.error = action.error.message;
    });

    builder.addCase(getFloorDetails.pending, (state) => {
      state.isLoadingFloorDetails = true;
    });
    builder.addCase(getFloorDetails.fulfilled, (state, action) => {
      state.isLoadingFloorDetails = false;
      state.floorDetails = action.payload;
    });
    builder.addCase(getFloorDetails.rejected, (state, action) => {
      state.isLoadingFloorDetails = false;
      state.error = action.error.message;
    });

    builder.addCase(getFloorAssetsAndShapes.pending, (state) => {
      state.isLoadingFloorAssetsAndShapes = true;
    });
    builder.addCase(getFloorAssetsAndShapes.fulfilled, (state, action) => {
      state.isLoadingFloorAssetsAndShapes = false;
      state.floorAssetsAndShapes = action.payload;
    });
    builder.addCase(getFloorAssetsAndShapes.rejected, (state, action) => {
      state.isLoadingFloorAssetsAndShapes = false;
      state.error = action.error.message;
    });

    builder.addCase(getFloorPlanByAsset.pending, (state) => {
      state.isLoadingFloorPlanByAsset = true;
    });
    builder.addCase(getFloorPlanByAsset.fulfilled, (state, action) => {
      state.isLoadingFloorPlanByAsset = false;
      state.floorPlanByAsset = action.payload;
    });
    builder.addCase(getFloorPlanByAsset.rejected, (state, action) => {
      state.isLoadingFloorPlanByAsset = false;
      state.error = action.error.message;
    });

    builder.addCase(acknowledgementFault.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(acknowledgementFault.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(acknowledgementFault.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(resolveFault.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(resolveFault.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(resolveFault.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(updateFloorPlan.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(updateFloorPlan.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(updateFloorPlan.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(getTodayFaultStats.pending, (state) => {
      state.isLoadingTodayFaultsStats = true;
    });
    builder.addCase(getTodayFaultStats.fulfilled, (state, action) => {
      state.isLoadingTodayFaultsStats = false;
      state.todayFaultsStats = action.payload;
    });
    builder.addCase(getTodayFaultStats.rejected, (state, action) => {
      state.isLoadingTodayFaultsStats = false;
      state.error = action.error.message;
    });
  },
});

export const { setFilter } = faultSlice.actions;

export default faultSlice.reducer;
